import { serialize as objectToFormData } from 'object-to-formdata'

export const toFormData = objectToFormData

export const unwrapFunction = (fn, ...args) => _.isFunction(fn) ? fn(...args) : fn

export const domElementWithin = (needle, haystack) => 
    needle === haystack || haystack.contains(needle)

export const asRoundedNumber = (value, decimals = 2) =>
    _.round(asNumber(value), decimals)

export const asPositiveRoundedNumber = (value, decimals = 2, defaultValue = 0) => {
    value = asRoundedNumber(value, decimals)
    return value < 0 ? defaultValue : value
}

export const asNumber = value => {
    value = _.toNumber(value)
    return _.isNaN(value) ? 0.00 : value
}
